module.exports = __webpack_public_path__ + "static/media/javascript.e71ef313.svg";